import { CALL_API } from '../common/middleware/api';

export const SHOW_COOKIE_PREFERENCES_MODAL = 'SHOW_COOKIE_PREFERENCES_MODAL';
export const HIDE_COOKIE_PREFERENCES_MODAL = 'HIDE_COOKIE_PREFERENCES_MODAL';

export const COOKIE_CONSENT_LOG_REQUEST = 'COOKIE_CONSENT_UPDATE_REQUEST';
export const COOKIE_CONSENT_LOG_SUCCESS = 'COOKIE_CONSENT_UPDATE_SUCCESS';
export const COOKIE_CONSENT_LOG_FAILURE = 'COOKIE_CONSENT_UPDATE_FAILURE';

export const showCookiePreferencesModal = () => ({ type: SHOW_COOKIE_PREFERENCES_MODAL });
export const hideCookiePreferencesModal = () => ({ type: HIDE_COOKIE_PREFERENCES_MODAL });

export const logCookieConsent = (cookieConsent) => ({
	[CALL_API]: {
		types: [COOKIE_CONSENT_LOG_REQUEST, COOKIE_CONSENT_LOG_SUCCESS, COOKIE_CONSENT_LOG_FAILURE],
		endpoint: `api/cookieConsent`,
		method: 'POST',
		request: cookieConsent
	}
});